import Close from '../src/Close/index';
export default Close;
